module.exports = __webpack_public_path__ + "static/media/3.548e64f7.jpg";